import {
  Box,
  Button,
  Divider,
  Tab,
  Tabs,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import bg from "../../assets/referralbg.png";
import {
  GET_REFERRAL_LINK,
  GET_USER_REFERRALS,
  GET_USER_TRANSACTIONS,
  USE_REFERRAL_BONUS,
  GET_DEFAULT_WALLET,
} from "../../Utils/Queries";
import { useLazyQuery } from "@apollo/client";

const Referral = () => {
  const [tab, setTab] = useState(0);
  const [copied, setCopied] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  // QUERIES - REFERRALS, TRANSACTIONS, WALLET ========================================================================================================

  const [getReferralLink, { data: linkData }] = useLazyQuery(GET_REFERRAL_LINK);
  const [getBonusBalance, { data: walletData }] =
    useLazyQuery(GET_DEFAULT_WALLET);
  const [withdraw] = useLazyQuery(USE_REFERRAL_BONUS);
  const [getUserReferrals, { data: userReferrals }] =
    useLazyQuery(GET_USER_REFERRALS);
  const [getUserTransactions, { data: userTransactions }] = useLazyQuery(
    GET_USER_TRANSACTIONS
  );

  // Real data fallback
  
  const referralLink = linkData?.getReferralLink?.referralLink || "Loading...";
  const bonus = walletData?.getDefaultWallet?.referralBonus || "0.00";
  const referrals = userReferrals?.fetchAllUserReferrals?.items || [];
  const transactions =
    userTransactions?.fetchAllUserReferralTransactions?.items || [];

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const handleWithdraw = () => {
    withdraw()
      .then((response) => {
        console.log("Withdrawal successful:", response);
      })
      .catch((err) => {
        console.error("Withdrawal failed:", err);
      });
  };

  useEffect(() => {
    getReferralLink();
    getUserReferrals();
    getUserTransactions();
    getBonusBalance();
  }, []);

  return (
    <Box sx={{ bgcolor: "#fff", p: 2 }}>
      <Box>
        <Typography sx={{ color: "#333", fontSize: "20px", fontWeight: 500 }}>
          Referral
        </Typography>
        <Divider sx={{ mt: 3 }} />

        <Box
          sx={{
            bgcolor: "#fff",
            p: 2,
            mt: 1,
            borderRadius: "10px",
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row",
              lg: "row",
            },
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              //   width: "300px",
              minWidth: "200px",
              maxWidth: "400px",
            }}
          >
            <Typography sx={{ fontSize: "14px", mb: 1 }}>
              Copy & share link to get $0.25 on each successful user sign up.
            </Typography>

            <TextField
              fullWidth
              variant="outlined"
              value={referralLink}
              InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#f3e5f5",
                  borderRadius: "8px",
                  fontSize: "14px",
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleCopy}>
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              size="small"
            />

            {copied && (
              <Typography sx={{ fontSize: "12px", color: "#4a148c", mt: 1 }}>
                Copied to clipboard!
              </Typography>
            )}

            <Box
              sx={{
                mt: 3,
                backgroundColor: "#5c3069",
                backgroundImage: `url(${bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "#fff",
                p: 4,
                borderRadius: "12px",
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography sx={{ fontSize: "18px", color: "#fff" }}>
                Referral Bonus
              </Typography>
              <Typography
                sx={{ fontSize: "36px", color: "#fff", fontWeight: "bold" }}
              >
                ${bonus}
              </Typography>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  bgcolor: "#fff",
                  color: "#4a148c",
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "30px",
                  width: "100%",
                  px: 4,
                  "&:hover": {
                    backgroundColor: "#f3e5f5",
                  },
                }}
                onClick={handleWithdraw}
              >
                Use Bonus
              </Button>
            </Box>
          </Box>

          {/* Right Section */}
          <Box
            sx={{
              flex: 1,
            }}
          >
            <Tabs
              value={tab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              sx={{
                mb: 2,
                "& .MuiTabs-flexContainer": {
                  justifyContent: "center",
                },
              }}
            >
              <Tab label="My Referrals" />
              <Tab label="Transaction" />
            </Tabs>
            {/* show this if no transactions or referrals */}
            {/* <Box
              sx={{
                border: "1px solid #eee",
                borderRadius: "8px",
                height: "230px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#bbb",
                fontSize: "14px",
              }}
            >
              No referral yet
            </Box> */}
            <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
              {tab === 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Email Address</TableCell>
                      <TableCell>Reward</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {referrals.length > 0 ? (
                      referrals.map((ref, index) => (
                        <TableRow key={index}>
                          <TableCell>{ref.email}</TableCell>
                          <TableCell>{ref.reward || "-"}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2} align="center">
                          No referrals found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              ) : (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transactions.length > 0 ? (
                      transactions.map((tx, index) => (
                        <TableRow key={index}>
                          <TableCell>{tx.date}</TableCell>
                          <TableCell>{tx.type}</TableCell>
                          <TableCell>{tx.amount}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No transactions found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Referral;
